/**
* @author huancheng.zhan<huancheng.zhan@ukelink.com>
* @description
* @since 2018/3/12
*/

import Axios from 'axios';
import Vue from 'vue';
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

import cookie from 'js-cookie'
import eventLib from '@/libs/eventLib'

Vue.use(LoadingPlugin);

/**
* @type {AxiosInstance}
*/
const service = Axios.create({
timeout: 60000
});
/**
* 请求拦截
**/
service.interceptors.request.use(
config => {



let IsShow = Vue.$vux.loading.isVisible();
if (!IsShow && !config["notShowLoading"]) {
Vue.$vux.loading.show({
text: 'Loading'
});
}


config.headers['Accept-Language'] = cookie.get('language') || navigator.language;

let partnerCode = Vue.prototype.ObjectMvno && Vue.prototype.ObjectMvno['partnerCodeP'] ? Vue.prototype.ObjectMvno['partnerCodeP'] : 'UKWEB';

let default_param = {
streamNo: partnerCode + `${+new Date()}${Math.floor(Math.random()*10000)}`,
partnerCode: partnerCode,
};
let domain = Vue.prototype.commonHelper.apiDomain();
config.url =  config.url;
if (config["noPartnerCode"]) {
delete default_param.partnerCode;
}
if (config.url.indexOf('/interfaces/getMvnoCode') !== -1) {

delete config.data;
} else {
config.data = Object.assign({}, config.data, default_param);
}

return config;
}
);
/**
* 响应拦截
**/
service.interceptors.response.use(
response => {

Vue.$vux.loading.hide();



let code = response.data.resultCode || response.data["subCode"];
let result = response.data;
if (code === "00000000" || code === "0000") {
Vue.prototype.NotInterceptors = false;
return result;
} else if (code === "00000006" || code === "00000007" || code === "00000008" || code === "00000026") {

if (Vue.prototype.NotInterceptors) {
Vue.prototype.NotInterceptors = false;
cookie.remove("access_token", {domain: '.' + location.hostname});
sessionStorage.clear();
localStorage.clear();
return Promise.reject(result);
}
cookie.remove("access_token", {domain: '.' + location.hostname});
sessionStorage.clear();
localStorage.clear();
eventLib.emit("loginTimeout"); 
return Promise.reject(result);
} else {
Vue.prototype.NotInterceptors = false;
return Promise.reject(result);
}
}, error => {

Vue.$vux.loading.hide();
Vue.prototype.NotInterceptors = false;

if (error.response) {
return Promise.reject(error.response);
}
}
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js